import React, { memo, useEffect } from "react"

import { useTranslation } from "core/hooks/useTranslation";

import Modal from "core/ui-kit/modal";
import Form from "core/ui-kit/form"
import { Col, Row } from "core/ui-kit/layout";

import { POPUP_SIZE } from "core/constants/common";

import isNull from "core/helpers/typeChecks/isNull";
import showSuccess from "core/helpers/common/showSuccess";

const AffiliatePassword = ({
    isVisible,
    data={},
    onClose
}) => {

    const { t } = useTranslation();

    const [formInstance] = Form.useForm();

    const onOkButtonClick = () => {
        navigator.clipboard.writeText(
            `${t("backoffice.affiliates.userName")}: ${data.userName}\n${t("backoffice.affiliates.password")}: ${data.password}`
        ).then(() => {
            showSuccess(t('backoffice.common.copied'));
            onClose();
        })
    }

    useEffect(() => {
        if(!isNull(data)){
            formInstance.setFieldsValue(data)
        }
    }, [data])

    return (
        <Modal 
            open={isVisible}
            title={t('backoffice.affiliates.affiliateCredentials')}
            cancelText={t('backoffice.common.close')}
            okText={t('backoffice.common.copy')}
            size={POPUP_SIZE.SMALL}
            onCancel={onClose}
            onOk={onOkButtonClick}
        >
            <Form 
                form={formInstance}
                initialValues={{
                    userName: data?.userName,
                    password: data?.password
                }}
            >
                <Row gutter={[16, 0]}>
                    <Col span={24}>
                        <Form.Input
                            name="userName" 
                            label={t("backoffice.affiliates.userName")}
                            disabled={true}
                        />
                    </Col>
                    <Col span={24}>
                        <Form.Input
                            name="password" 
                            label={t("backoffice.affiliates.password")}
                            disabled={true}
                            className="rt--form-item-without-margin"
                        />
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}

export default memo(AffiliatePassword)